import React from "react";
import assetLocations from "assetLocations";

export type ScribbleVariant = "v1" | "v2" | "v3";

interface IProps {
    variant: ScribbleVariant;
}

export default function ScribbleImage(props: IProps) {
    const { variant } = props;

    return <img src={assetLocations.scribbles[variant]} alt={`${variant} Scribble`} />;
}
